import XSelect from 'emberx-select/components/x-select';
export default XSelect;
